import styled from 'styled-components';

export const LoginLogo = styled.div`
  display: flex;
  align-content: center;
  flex-direction: column;
`;

export const LoginLogoSpan = styled.span`
  margin: 0 -3px;
  font-size: 18px;
  font-weight: 300;  
`;

export const TitleComplete = styled.span`
  font-family: 'Proxima Nova';
  letter-spacing: -0.02em;
  margin-bottom: 16px;
  align-items: center;
  text-align: center;
  font-style: normal;
  margin-top: 75px;
  line-height: 120%;
  font-weight: 600;
  font-size: 1.5em;
  color: #2B323B;
  display: flex;
`;

export const DetailSuscription = styled.div`
  width: 406px;
  display: flex;  
  flex-direction: column;
  justify-content: flex-start;
  @media(max-width: 1190px) {
    width: 100%;
  }
  @media(max-width: 701px) {
    max-width: 472px;
  }
`;

export const TitlePurchase = styled.span`
  font-family: 'Proxima Nova';
  margin-bottom: 16px;
  letter-spacing: -0.02em;
  font-style: normal;
  line-height: 120%;
  text-align: left;
  font-weight: 600;
  color: #2B323B;
  font-size: 1.5em;
`;

export const ContainerLogoSuscription = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3px;
  gap: 10px;
  width: 40px;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #D8DDE3;
  box-shadow: 0px 12px 16px 4px rgba(0, 14, 51, 0.02);
  border-radius: 4px;
  flex: none;
  order: 0;
  flex-grow: 0;
`;

export const LogoSuscription = styled.img`
  width: 24.69px;
  height: 23.58px;
`;

export const TitleSuscription = styled.span`
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 400;
  font-size: 0.75em;
  line-height: 20px;
  margin-bottom: 8px;
  color: #38424D;
  height: 13px;
`;

export const PriceSuscription = styled.span`
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  color: #38424D;
  font-size: 1em;
  height: 13px;
`;

export const CheckoutComplete = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0 26px;
  font-size: 16px;
  margin-top: 32px;
  padding-top: 32px;
  margin-bottom: 10vh;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: flex-start;
  border-top: 1px solid #EBEDF2;
  @media(max-width: 426px) {
    padding-top: 6vh;
    font-size: 14px;
  }
`;

export const SubtitleComplete = styled.span`
  display: flex;
  font-size: 16px;
  font-weight: 400;
  color: #38424D;
  line-height: 120%;
  font-style: normal;
  text-align: center;
  margin-bottom: 1em;
  align-items: center;
  font-family: 'Proxima Nova';
`;

export const ExpirationContainer = styled.div`
  border: 1px solid #EBEDF2;
  justify-content: center;
  box-sizing: border-box;
  margin-bottom: 40px;
  flex-direction: row;
  align-items: center;
  max-width: 472px;
  display: flex;
  padding: 24px;
  height: 112px;
  width: 472px;
  @media(max-width: 1190px) {
    padding: 12px;
    width: calc(100% + 52px);
  }
`;

export const DateContainer = styled.div`
  &:first-child {
    margin-right: 38px;
  }  
  &:last-child {
    margin-left: 38px;
  }
  @media(max-width: 1190px) {
    &:first-child {
    margin-right: 7%;
    }  
    &:last-child {
      margin-left: 7%;
    }
  }
`;

export const Expiration = styled.span`
  font-family: 'Proxima Nova';
  align-items: center;
  margin-bottom: 4px;
  font-style: normal;
  line-height: 120%;
  color: #607184;
  font-weight: 400;
  font-size: 1em;
  display: flex;
`;

export const Date = styled.span`
  font-family: 'Proxima Nova';
  letter-spacing: -0.02em;
  font-style: normal;
  line-height: 120%;
  color: #000000;
  font-weight: 600;
  font-size: 1.5em;
  @media(max-width: 1190px) {
    font-size: 1.25em;
  }
  @media(max-width: 700px) {
    font-size: 1.375em;
  }
`;

export const CompletePurchaseWrapper = styled.div`
  width: 406px;
  @media(max-width: 1190px) {
    width: 100%;
  }
  @media(max-width: 701px) {
    max-width: 472px;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  margin-left: 16px;
  flex-direction: column;
`;

export const TitleWrapper = styled.div`
  display: flex;
  margin-bottom: 2em;
  align-items: center;
`;